import { createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, createTextVNode as _createTextVNode, normalizeClass as _normalizeClass, resolveComponent as _resolveComponent, createVNode as _createVNode, toDisplayString as _toDisplayString, withCtx as _withCtx, createBlock as _createBlock } from "vue"
import _imports_0 from '@/assets/filterIcon_Disabled.svg'
import _imports_1 from '@/assets/filter.svg'
import _imports_2 from '@/assets/cancel.svg'


const _hoisted_1 = { class: "pr-5 pl-5 pt-3 page-fill" }
const _hoisted_2 = {
  class: "row w-full mb-3 justify-between flex",
  style: {"align-items":"center"}
}
const _hoisted_3 = { class: "cardbody" }
const _hoisted_4 = { class: "flex flex-row-reverse items-center" }
const _hoisted_5 = { class: "flex flex-row-reverse items-center gap-3" }
const _hoisted_6 = {
  key: 0,
  src: _imports_0,
  class: "filterIcon"
}
const _hoisted_7 = {
  key: 1,
  src: _imports_1,
  class: "filterIcon"
}
const _hoisted_8 = { class: "mt-5 table-section" }
const _hoisted_9 = { key: 0 }
const _hoisted_10 = { class: "flex items-center justify-between py-4 px-2 rounded" }
const _hoisted_11 = { class: "statuscontainer popupbodycontainer" }
const _hoisted_12 = { class: "formcontainer flex flex-col" }
const _hoisted_13 = { class: "row flex flex-row w-full" }
const _hoisted_14 = { class: "row flex flex-row w-full" }
const _hoisted_15 = { class: "w-6/12" }
const _hoisted_16 = { class: "mb-3 mt-2 text-sm" }
const _hoisted_17 = { class: "w-3/6 leftspacing" }
const _hoisted_18 = { class: "mb-3 mt-2 text-sm" }
const _hoisted_19 = { class: "row flex flex-row w-full" }
const _hoisted_20 = { class: "" }
const _hoisted_21 = { class: "mb-3 mt-2 text-sm" }
const _hoisted_22 = { class: "row flex flex-row w-full" }
const _hoisted_23 = { class: "w-6/12" }
const _hoisted_24 = { class: "mb-3 mt-2 text-sm" }
const _hoisted_25 = { class: "w-3/6 leftspacing" }
const _hoisted_26 = { class: "mb-3 mt-2 text-sm" }
const _hoisted_27 = { class: "row flex flex-row w-full" }
const _hoisted_28 = { class: "w-3/6" }
const _hoisted_29 = { class: "w-3/6 leftspacing" }
const _hoisted_30 = { class: "mb-3 mt-2 text-sm" }

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_tableData = _resolveComponent("tableData")!
  const _component_tool_tip = _resolveComponent("tool-tip")!
  const _component_popup = _resolveComponent("popup")!

  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createElementVNode("div", _hoisted_2, [
      _cache[3] || (_cache[3] = _createElementVNode("h1", null, "Mapping", -1)),
      _createElementVNode("div", _hoisted_3, [
        _createElementVNode("div", _hoisted_4, [
          _createElementVNode("div", _hoisted_5, [
            _createElementVNode("button", {
              class: _normalizeClass(["flex", _ctx.tableRow.length == 0 ? 'filterButtondisabled pointer-events-none' : 'filterButton']),
              onClick: _cache[0] || (_cache[0] = 
//@ts-ignore
(...args) => (_ctx.filterOpen && _ctx.filterOpen(...args)))
            }, [
              (_ctx.tableRow.length == 0)
                ? (_openBlock(), _createElementBlock("img", _hoisted_6))
                : (_openBlock(), _createElementBlock("img", _hoisted_7)),
              _cache[2] || (_cache[2] = _createTextVNode(" Filters "))
            ], 2)
          ])
        ])
      ])
    ]),
    _cache[13] || (_cache[13] = _createElementVNode("div", { class: "text-xs mt-3" }, " Data Oragnisation is the practice of categorizing and classifyinf data to make it more usable.Similar to a file folder,where we keep important documents ,you'll need to arrange your data in the most logical and orderly fashion ,so you -- and anyone else who accesses it -- can easily find what they're looking for .Data organization is the practice of categorizing and classifying data to make it more usable. Similar to a file folder, when we keep important documents,you'll need to arrange your data in the most logical and orderly fashion. ", -1)),
    _createElementVNode("div", _hoisted_8, [
      _createVNode(_component_tableData, {
        class: "flex-1 min-h-0",
        tableRowData: _ctx.tableRow,
        headersData: _ctx.headers,
        tableRouteArr: _ctx.optionsValue,
        loadData: _ctx.dataLoading
      }, null, 8, ["tableRowData", "headersData", "tableRouteArr", "loadData"]),
      (_ctx.toolTipActive)
        ? (_openBlock(), _createElementBlock("div", _hoisted_9, [
            _createVNode(_component_tool_tip, { tipText: _ctx.toolTipText }, null, 8, ["tipText"])
          ]))
        : _createCommentVNode("", true)
    ]),
    (_ctx.showActivityPopup)
      ? (_openBlock(), _createBlock(_component_popup, {
          key: 0,
          popUp: _ctx.showActivityPopup
        }, {
          header: _withCtx(() => [
            _createElementVNode("div", _hoisted_10, [
              _cache[5] || (_cache[5] = _createElementVNode("h1", { class: "pl-2" }, "Activity", -1)),
              _createElementVNode("button", {
                class: "float-right text-3xl",
                onClick: _cache[1] || (_cache[1] = ($event: any) => (_ctx.onCancelbtn()))
              }, _cache[4] || (_cache[4] = [
                _createElementVNode("img", {
                  src: _imports_2,
                  class: "h-5 w-5 cursor-pointer"
                }, null, -1)
              ]))
            ])
          ]),
          default: _withCtx(() => [
            _createElementVNode("fieldset", null, [
              _createElementVNode("div", null, [
                _createElementVNode("div", null, [
                  _createElementVNode("div", _hoisted_11, [
                    _createElementVNode("div", _hoisted_12, [
                      _createElementVNode("div", _hoisted_13, [
                        _createElementVNode("div", _hoisted_14, [
                          _createElementVNode("div", _hoisted_15, [
                            _cache[6] || (_cache[6] = _createElementVNode("label", { class: "text-xs font-extrabold" }, "Activity", -1)),
                            _createElementVNode("div", _hoisted_16, _toDisplayString(_ctx.activityObj?.businessProcessName || 'N/A'), 1)
                          ]),
                          _createElementVNode("div", _hoisted_17, [
                            _cache[7] || (_cache[7] = _createElementVNode("label", { class: "text-xs font-extrabold" }, "Team", -1)),
                            _createElementVNode("div", _hoisted_18, _toDisplayString(_ctx.activityObj?.teamName || 'N/A'), 1)
                          ])
                        ])
                      ]),
                      _createElementVNode("div", _hoisted_19, [
                        _createElementVNode("div", _hoisted_20, [
                          _cache[8] || (_cache[8] = _createElementVNode("label", { class: "text-xs font-extrabold" }, "Description", -1)),
                          _createElementVNode("div", _hoisted_21, _toDisplayString(_ctx.activityObj?.description || 'N/A'), 1)
                        ])
                      ]),
                      _createElementVNode("div", _hoisted_22, [
                        _createElementVNode("div", _hoisted_23, [
                          _cache[9] || (_cache[9] = _createElementVNode("label", { class: "text-xs font-extrabold" }, "Activity Owner", -1)),
                          _createElementVNode("div", _hoisted_24, _toDisplayString(_ctx.activityObj?.name || 'N/A'), 1)
                        ]),
                        _createElementVNode("div", _hoisted_25, [
                          _cache[10] || (_cache[10] = _createElementVNode("label", { class: "text-xs font-extrabold" }, "Location", -1)),
                          _createElementVNode("div", _hoisted_26, _toDisplayString(_ctx.activityObj?.displayName || 'N/A'), 1)
                        ])
                      ]),
                      _createElementVNode("div", _hoisted_27, [
                        _createElementVNode("div", _hoisted_28, [
                          _cache[11] || (_cache[11] = _createElementVNode("label", { class: "text-xs font-extrabold" }, "Criticality", -1)),
                          (_ctx.activityObj?.criticality)
                            ? (_openBlock(), _createElementBlock("div", {
                                key: 0,
                                class: _normalizeClass(["rounded h-5 w-28 mt-2 flex items-center justify-center", _ctx.colorLabelBg(_ctx.activityObj.criticality)])
                              }, [
                                _createElementVNode("div", {
                                  class: _normalizeClass(["text-xs", _ctx.colorLabelText(_ctx.activityObj.criticality)])
                                }, _toDisplayString(_ctx.getProirityLabel(_ctx.activityObj.criticality)), 3)
                              ], 2))
                            : _createCommentVNode("", true)
                        ]),
                        _createElementVNode("div", _hoisted_29, [
                          _cache[12] || (_cache[12] = _createElementVNode("label", { class: "text-xs font-extrabold" }, "Job Title", -1)),
                          _createElementVNode("div", _hoisted_30, _toDisplayString(_ctx.activityObj?.role || 'N/A'), 1)
                        ])
                      ])
                    ])
                  ])
                ])
              ])
            ])
          ]),
          _: 1
        }, 8, ["popUp"]))
      : _createCommentVNode("", true)
  ]))
}